import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0D0D0D] text-[#FAF8F5] pt-24 pb-10 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <button
        data-testid="footer-cta"
        onClick={() => scrollToId("reserver")}
        className="group block w-full text-left"
      >
        <p className="font-display font-bold uppercase tracking-tight leading-[0.9] text-[13vw] lg:text-[9rem] group-hover:text-[#CBD5C0] transition-colors duration-700">
          SOLAMOVE
        </p>
      </button>
      <p className="font-mono-alt text-xs sm:text-sm uppercase tracking-[0.35em] text-[#FAF8F5]/50 mt-6">
        Every step makes you stronger.
      </p>

      <div className="mt-20 pt-10 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-8">
        <nav className="flex flex-wrap items-center gap-x-8 gap-y-4 text-[11px] uppercase tracking-[0.2em] text-[#FAF8F5]/60">
          <a data-testid="footer-link-instagram" href="https://www.instagram.com/solamove/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#FAF8F5] transition-colors duration-300">
            <Instagram size={14} strokeWidth={1.5} /> Instagram
          </a>
          <a data-testid="footer-link-contact" href="mailto:solamove@outlook.fr" className="normal-case tracking-normal hover:text-[#FAF8F5] transition-colors duration-300">solamove@outlook.fr</a>
          <Link data-testid="footer-link-legal" to="/mentions-legales" className="hover:text-[#FAF8F5] transition-colors duration-300">Mentions légales</Link>
          <Link data-testid="footer-link-privacy" to="/politique-de-confidentialite" className="hover:text-[#FAF8F5] transition-colors duration-300">Politique de confidentialité</Link>
          <span data-testid="footer-cgv-note" className="text-[#FAF8F5]/30">CGV — à l'ouverture des ventes</span>
        </nav>
        <Link data-testid="admin-dashboard-link" to="/admin" className="inline-flex items-center gap-2 self-start border border-white/30 px-5 py-2.5 rounded-full text-[11px] uppercase tracking-[0.2em] text-[#FAF8F5]/80 hover:bg-[#FAF8F5] hover:text-[#0D0D0D] transition-colors duration-300">
          Espace admin
        </Link>
      </div>
      <p className="mt-10 text-[11px] text-[#FAF8F5]/35">© 2026 SOLAMOVE — Tous droits réservés.</p>
    </div>
  </footer>
);
